export { ReactComponent as AlmostThere } from './almostThere.svg';
export { ReactComponent as GoodJob } from './goodJob.svg';
export { ReactComponent as NeedWork } from './needWork.svg';